import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ParametroLicitacao } from '../../../entidade/licitacao/parametro-licitacao.model';
import { BaseResourceService } from '../../../models/services/base-resource.service';

@Injectable({
  providedIn: 'root'
})
export class ParametroLicitacaoService extends BaseResourceService<ParametroLicitacao> {

  constructor(
    protected injector: Injector
  ) {
    super(`parametros-licitacao`, injector);
  }

  public obterParametro(orgao: number): Observable<ParametroLicitacao> {
    return this.http.get<ParametroLicitacao>(
      `${this.login.cidade.id}/${this.api}/obter/${orgao}`, this.httpOptions()).pipe(
        map(res => res),
        catchError(err => this.handleError(err))
      );
  }

}
